import { useState, useEffect } from "react";
import { APP_STORE_URL, PLAY_STORE_URL } from "../constants/storeUrls";

const ofellioIcon = require("../pages/image/ofellio-icon.png");
const playBadge = require("../pages/image/play-store.png");
const appleBadge = require("../pages/image/app-store.png");

const PWAInstallPrompt = () => {
  const [showPrompt, setShowPrompt] = useState(false);

  useEffect(() => {
    const isMobileBrowser =
      typeof window !== "undefined" &&
      (window.innerWidth < 768 ||
        /Android|iPhone|iPad|iPod/i.test(navigator.userAgent || ""));
    if (!isMobileBrowser) return undefined;

    const dismissedTime = localStorage.getItem("pwa-prompt-dismissed");
    let shouldShow = true;
    if (dismissedTime) {
      const daysSinceDismissed =
        (Date.now() - parseInt(dismissedTime, 10)) / (1000 * 60 * 60 * 24);
      if (daysSinceDismissed < 7) shouldShow = false;
    }
    if (!shouldShow) return undefined;
    const t = setTimeout(() => setShowPrompt(true), 3000);
    return () => clearTimeout(t);
  }, []);

  const handleDismiss = () => {
    localStorage.setItem("pwa-prompt-dismissed", Date.now().toString());
    setShowPrompt(false);
  };

  if (!showPrompt) return null;

  return (
    <div className="pwa-prompt-container">
      <div className="pwa-prompt">
        <button
          className="pwa-close-button"
          onClick={handleDismiss}
          aria-label="Close"
        >
          ×
        </button>
        <div className="pwa-content">
          <div className="pwa-header-row">
            <div className="pwa-icon-container">
              <img
                src={ofellioIcon}
                alt="Ofellio"
                className="pwa-app-icon"
              />
            </div>
            <div className="pwa-instructions">
              <p className="pwa-instructions-title">
                Download Ofellio app on your phone
              </p>
            </div>
          </div>
          <div className="pwa-store-badges">
            <a href={PLAY_STORE_URL} target="_blank" rel="noopener noreferrer">
              <img
                src={playBadge}
                alt="Get it on Google Play"
                width="120"
                height="36"
              />
            </a>
            <a href={APP_STORE_URL} target="_blank" rel="noopener noreferrer">
              <img
                src={appleBadge}
                alt="Download on the App Store"
                width="120"
                height="36"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PWAInstallPrompt;
